(function () {
  var track = document.querySelector("[data-track]");
  var dotsWrap = document.querySelector("[data-dots]");
  if (!track || !dotsWrap) return;

  var cards = Array.prototype.slice.call(track.children);
  var prevBtn = document.querySelector(".highlights__arrow--prev");
  var nextBtn = document.querySelector(".highlights__arrow--next");

  function cardStep() {
    if (!cards.length) return 0;
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap || "0");
    return cards[0].getBoundingClientRect().width + gap;
  }

  function cardsPerView() {
    return Math.max(1, Math.round(track.clientWidth / cardStep()));
  }

  function pageCount() {
    return Math.max(1, Math.ceil(cards.length / cardsPerView()));
  }

  function buildDots() {
    dotsWrap.innerHTML = "";
    var pages = pageCount();
    for (var i = 0; i < pages; i++) {
      var dot = document.createElement("button");
      dot.type = "button";
      dot.className = "highlights__dot";
      dot.setAttribute("aria-label", "Ir para página " + (i + 1));
      dot.addEventListener("click", function (index) {
        return function () {
          track.scrollTo({ left: index * cardsPerView() * cardStep(), behavior: "smooth" });
        };
      }(i));
      dotsWrap.appendChild(dot);
    }
    updateActiveDot();
  }

  function updateActiveDot() {
    var dots = dotsWrap.children;
    if (!dots.length) return;
    var page = Math.round(track.scrollLeft / (cardsPerView() * cardStep()));
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle("is-active", i === page);
    }
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", function () {
      track.scrollBy({ left: -cardStep(), behavior: "smooth" });
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      track.scrollBy({ left: cardStep(), behavior: "smooth" });
    });
  }

  var scrollTimer;
  track.addEventListener("scroll", function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(updateActiveDot, 80);
  });

  window.addEventListener("resize", buildDots);
  buildDots();
})();
